import { defineMessages } from 'react-intl'

// E8 F8-4 persona splash / picker strings.
const messages = defineMessages({
  pickerTitle: {
    id: 'persona.pickerTitle',
    defaultMessage: 'Choose how to continue',
  },
  pickerSubtitle: {
    id: 'persona.pickerSubtitle',
    defaultMessage: 'You have more than one role in this workspace. Select one to continue.',
  },
  accountOwner: {
    id: 'persona.accountOwner',
    defaultMessage: 'Account owner',
  },
  errorTitle: {
    id: 'persona.errorTitle',
    defaultMessage: 'No access to this workspace',
  },
  errorBody: {
    id: 'persona.errorBody',
    defaultMessage:
      'Your account does not have a role in this workspace. Check the address, or contact your administrator.',
  },
  failedTitle: {
    id: 'persona.failedTitle',
    defaultMessage: 'Could not load your workspaces',
  },
  failedBody: {
    id: 'persona.failedBody',
    defaultMessage: 'Something went wrong loading your account. This is usually temporary — try again.',
  },
  retry: {
    id: 'persona.retry',
    defaultMessage: 'Try again',
  },
  signOut: {
    id: 'persona.signOut',
    defaultMessage: 'Sign out',
  },
  // E8 F8-5 persona switcher (in-header).
  switcherLabel: {
    id: 'persona.switcherLabel',
    defaultMessage: 'Switch workspace or role',
  },
  // E8 8.5.3 / WI 577 — a11y label that names the current persona for screen readers.
  switcherAriaLabel: {
    id: 'persona.switcherAriaLabel',
    defaultMessage: 'Switch persona, currently {persona}',
  },
  thisWorkspace: {
    id: 'persona.thisWorkspace',
    defaultMessage: 'This workspace',
  },
  otherWorkspaces: {
    id: 'persona.otherWorkspaces',
    defaultMessage: 'Other workspaces',
  },
})

export default messages
